<script>
    export let title;
    export let pertainsTo = null;
    export let description = '';
</script>

<div class="metadata-section">
    <h5>{title}</h5>

    {#if pertainsTo}
        <p>
            Pertains to:
            <i>
                {#each pertainsTo as topic, idx}
                    {topic.title}{idx < pertainsTo.length -1 ? ', ' : ''}
                {/each}
            </i>
        </p>
    {/if}


    {@html description}
</div>

<style>
    h5 {
        font-weight: 700;
        font-size: 14px;
        margin-bottom: 8px;
    }
</style>
